/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import { ToastComponent } from "./toast-component";
import { ToastVariantProps } from "./toast.types";

export const SuccessToast = React.forwardRef<HTMLDivElement>((props: { message: { props: ToastVariantProps } }, ref) => <ToastComponent ref={ref} {...props.message.props} />);
export const InfoToast = React.forwardRef<HTMLDivElement>((props: { message: { props: ToastVariantProps } }, ref) => <ToastComponent ref={ref} {...props.message.props} />);
export const ErrorToast = React.forwardRef<HTMLDivElement>((props: { message: { props: ToastVariantProps } }, ref) => <ToastComponent ref={ref} {...props.message.props} />);
export const WarningToast = React.forwardRef<HTMLDivElement>((props: { message: { props: ToastVariantProps } }, ref) => <ToastComponent ref={ref} {...props.message.props} />);
